import ImageBox from "./ImageBox";
import "./Style.scss";

export { ImageBox };
